// extracted by mini-css-extract-plugin
export var gridOverrideMarginMobile = "v_bs";
export var homeLoansContainer = "v_bq";
export var title = "v_br";
export var titleContainer = "v_bk";